<template>
  <div class="showdowInfoContent">
    <div class="titleClass">把便捷工作装进口袋</div>
    <div class="textClass">随时随地 解决问题 提高您的工作效率</div>
    <div class="bottomClass">
      <div class="bottomClassLeft">
        <PhoneTypeBtn @click="androidClick" class="btnClass" style="margin-bottom: 40px;"
        nomalIcon="AndroidIcon.png" 
        selectIconText="AndroidIcon.png" titleText="Android版下载"  :isSelect="codeType == 0"/>
        <PhoneTypeBtn @click="iphoneClick" class="btnClass" 
        nomalIcon="iPhoneIcon.png" 
        selectIconText="iPhoneIcon.png" 
        titleText="iPhone版下载" 
        :isSelect="codeType == 1"/>
      </div>
      <div class="bottomClassRight">
        <img style="width: 200px; height: 200px; margin-top: 80px;" src="https://img0.baidu.com/it/u=3584759695,3470619884&fm=253&fmt=auto&app=138&f=GIF?w=198&h=198" alt="" />
        <div class="scanText">扫描二维码下载竞小侠助手APP体验</div>
      </div>
    </div>
  </div>
</template>

<script>
import PhoneTypeBtn from "./publicComm/phoneTypeBtn.vue";
export default {
  name: "shadowInfo",
  components: {
    PhoneTypeBtn
  },
  data() {
    return {
        // 0安卓 1苹果
        codeType: 0
    };
  },
  methods: {
    androidClick() {
      this.codeType = 0;
    },
    iphoneClick() {
      this.codeType = 1;
    }
  }
};
</script>

<style>
.showdowInfoContent {
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.titleClass {
  height: 84px;
  font-size: 84px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 84px;
  color: rgba(255, 255, 255, 1);
  text-align: left;
  vertical-align: top;
}

.textClass {
  width: 100%;
  margin-top: 40px;

  height: 36px;
  font-size: 36px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 36px;
  color: rgba(255, 255, 255, 0.8);
  text-align: center;
  vertical-align: top;
}

.bottomClass {
  display: flex;
  flex-direction: row;
}

.btnClass {
  width: 282px;
  height: 96px;
}

.bottomClassLeft {
    margin-top: 80px;
    flex-direction: column;
    justify-content: center;
}

.bottomClassRight {
    margin-left: 53px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.scanText {
    margin-top: 40px;
    color: #FFFFFF;
}
</style>